
import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'

export default     {
    path: '/examinationPaper',
    name: 'ExaminationPaper',
    meta: {
        title: '教研管理',
        keepAlive: false
    },
    component: Layout,
    redirect: '/examinationPaper/testPaper',
    children: [
        {
            path: 'testPaper',
            name: 'TestPaper',
            meta: {
                title: '试卷列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/examinationPaper/testPaper/Index.vue'], resolve),
        },
        {
            path: 'testPaper',
            meta: {
                title: '试卷列表',
                keepAlive: false
            },
            component: Empty,
            children: [
                {
                    path: 'testQuestions',
                    name: 'TestQuestions',
                    meta: {
                        title: '试题列表',
                        keepAlive: false
                    },
                    component: resolve => require(['@/views/examinationPaper/testQuestions/Index.vue'], resolve),
                },
                {
                    path: 'testQuestions',
                    meta: {
                        title: '试题列表',
                        keepAlive: false
                    },
                    component: Empty,
                    children: [
                        {
                            path: '/examinationPaper/testPaper/testQuestions/radioTestA1Detailaaa',
                            name: 'radioTestA1Detail',
                            alias:'/radioTestA1Detailaaa',
                            meta: {
                                title: '预览试题',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA1Detail.vue'], resolve),

                        },{
                            path: '/examinationPaper/testPaper/testQuestions/radioTestA3Detailaaa',
                            name: 'radioTestA3Detail',
                            alias:'/radioTestA3Detailaaa',
                            meta: {
                                title: '预览试题',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA3Detail.vue'], resolve),

                        },{
                            path: '/examinationPaper/testPaper/testQuestions/radioTestBDetailaaa',
                            name: 'radioTestBDetail',
                            alias:'/radioTestBDetailaaa',
                            meta: {
                                title: '预览试题',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestBDetail.vue'], resolve),

                        },
                        {
                            path: 'addTestQuestions',
                            name: 'AddTestQuestions',
                            meta: {
                                title: '添加试题',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/examinationPaper/addTestQuestions/Index.vue'], resolve),
                        },
                        {
                            path: 'addTestQuestions',
                            name: 'AddTestQuestionsy',
                            meta: {
                                title: '添加试题',
                                keepAlive: false
                            },
                            component: Empty,
                            children: [
                                {
                                    path: '/examinationPaper/testPaper/testQuestions/addTestQuestions/radioTestA1Detailddd',
                                    name: 'radioTestA1Detail0',
                                    alias:'/radioTestA1Detailddd',
                                    meta: {
                                        title: '预览试题',
                                        keepAlive: false
                                    },
                                    component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA1Detail.vue'], resolve),

                                },{
                                    path: '/examinationPaper/testPaper/testQuestions/addTestQuestions/radioTestA3Detailddd',
                                    name: 'radioTestA3Detail0',
                                    alias:'/radioTestA3Detailddd',
                                    meta: {
                                        title: '预览试题',
                                        keepAlive: false
                                    },
                                    component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA3Detail.vue'], resolve),

                                },{
                                    path: '/examinationPaper/testPaper/testQuestions/addTestQuestions/radioTestBDetailddd',
                                    name: 'radioTestBDetail0',
                                    alias:'/radioTestBDetailddd',
                                    meta: {
                                        title: '预览试题',
                                        keepAlive: false
                                    },
                                    component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestBDetail.vue'], resolve),

                                }
                            ],

                        }
                    ]
                },
            ]
        },

    ]
}


